const chainLists = {
  ES: {
    QSR: [
      "McDonald's", "Burger King", "Popeye's", "Telepizza", "KFC", "Viena Establiments", "Five Guys",
      "Pans & Co", "Rodilla", "Papizza", "Carl's Jr", "Taco Bell", "The Fitzgerald", "Papa John’s",
      "Pizza Móvil", "Don G", "Pomodoro", "Pizzería Carlos", "Basics", "Basics Dark", "Distrito Burger", "Avanza Dark", "Ikea Bistro"
    ],
    CASUAL: [
      "Udon", "Ribs", "Hamb. Nostra", "La Tagliatella", "MasQMenos", "Volapié", "Goiko", "Tony Roma's",
      "Chelinda", "La Famiglia", "Cantina Mariachi", "Muerde la Pasta", "Lateral",
      "Lizarran", "Café y Tapas", "DHS", "FrescCo", "Singulares Cía del Trópico", "Grosso Napoletano",
      "Saona", "Ditaly", "La Boca Te Lía", "Vezzo", "Ikea Restaurante"
    ],
    CAFE: [
      "McCafé", "Tim Horton's", "Jamaica", "Santa Gloria", "L'Obrador", "Café de Indias",
      "Café y Té", "Panaria", "Rodilla Café", "Levadura Madre", "El Fornet", "Pans Café", "Dunkin’",
      "Bombon Boss", "La Julietta", "Syra Coffee", "Ikea Café"
    ]
  },
  PT: {
    QSR: [
      "Burger King", "Telepizza", "KFC", "Pans & Co", "Milt", "Sol", "La Tagliatella",
      "Taco Bell", "Pizza Hut", "Pret a Manger", "Pasta Café", "La Famiglia", "Papa John’s", "A Padaria Portuguesa"
    ]
  },
  IRL:{QSR: ["McDonald's","Domino's Pizza","KFC","Chain #4","Chain #5"]}
}

export default chainLists;